import { useState } from 'react';
import { UserCog } from 'lucide-react';
import {
  realtyButtonsTitles,
  realtyContactsButtons,
} from '../../../../data/cardRealty';
import { IconButtonTemplate } from '../../buttons/IconButtonTemplate';
import { VisitsBar } from '../../VisitsBar';
import { selectIsAdmin } from '../../../../redux/features/user/userSelectors';
import { useSelector } from 'react-redux';
import { ButtonTemplate } from '../../buttons/ButtonTemplate';
import { Dialog } from '../../Dialog';
import { ReassignRealty } from '../../../form/forms/realtyForm/ReassignRealty';

export const ContactsButtons = ({
  agent = {},
  realtyId,
  ttc = '',
}) => {
  const [showVisitsBar, setShowVisitsBar] = useState(false);
  const [showOwnerForm, setShowOwnerForm] = useState(false);

  const isAdmin = useSelector(selectIsAdmin);

  const handleTaskVisitsClick = () => {
    setShowVisitsBar(!showVisitsBar);
  };

  const buttonsHandlers = {
    // Collaboration dialog (AddAssignee) is deferred to the collaboration phase.
    [realtyButtonsTitles.assignedTo]: () => {},
    [realtyButtonsTitles.tasksVisits]: handleTaskVisitsClick,
  };

  return (
    <div className="absolute flex flex-col items-end gap-1 right-0 bottom-1.5 z-[1]">
      {ttc && (
        <div className="flex items-center gap-1 w-max px-1 bg-white rounded-l opacity-80">
          <span className="text-xs text-blackColor">&#8364; {`${ttc}`} TTC</span>
        </div>
      )}

      <div className="flex items-center gap-1 px-1 bg-white rounded-l opacity-80">
        {realtyContactsButtons.map(button => {
          const handleClick = buttonsHandlers[button.title];

          return button?.hasText ? (
            <ButtonTemplate
              key={button.id}
              handleClick={() => handleClick(button)}
              text={agent?.name}
              classes={button.classes}
              isSmall={true}
              isSmallBorder={true}
              size={14}
              tooltipText={button.tooltipText}
            />
          ) : (
            <IconButtonTemplate
              key={button.id}
              handleClick={() => handleClick(button)}
              icon={button.icon}
              classes={button.classes}
              isSmallBorder={true}
              size={14}
              tooltipText={button.tooltipText}
            />
          );
        })}

        {isAdmin && (
          <IconButtonTemplate
            handleClick={() => setShowOwnerForm(true)}
            icon={UserCog}
            classes="border-white"
            isSmallBorder={true}
            size={14}
            tooltipText="Change owner"
          />
        )}
      </div>

      {showVisitsBar && (
        <VisitsBar
          setIsOpen={setShowVisitsBar}
          classes="bottom-7 right-0"
          realtyId={realtyId}
        />
      )}

      {showOwnerForm && (
        <Dialog
          content={
            <ReassignRealty
              realtyId={realtyId}
              agent={agent}
              handleClose={() => setShowOwnerForm(false)}
            />
          }
          isOpen={showOwnerForm}
          onClose={() => setShowOwnerForm(false)}
        />
      )}
    </div>
  );
};
